import React, { useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-config';
import AppShell from './components/AppShell';
import { processOfflineQueue } from './services/uploadService';
import { useServiceWorker } from './contexts/ServiceWorkerContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

// Configure Amplify
Amplify.configure(awsConfig);

function App() {
  const { onUpdate } = useServiceWorker();

  // Register service worker with update callback
  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: onUpdate
    });
  }, [onUpdate]);

  // Handle online/offline events to auto-process offline queue
  useEffect(() => {
    const handleOnline = async () => {
      console.log('Device came online, processing offline upload queue');

      try {
        const result = await processOfflineQueue((progress) => {
          console.log('Queue processing progress:', progress);
        });

        if (result.processed > 0) {
          console.log(`${result.processed} pending recording(s) uploaded successfully`);
        }

        if (result.failed > 0) {
          console.log(`${result.failed} recording(s) failed to upload`);
        }
      } catch (error) {
        console.error('Error processing offline queue:', error);
      }
    };

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background font-sans">
      <AppShell />
    </div>
  );
}

export default App;
